import { render, staticRenderFns } from "./data-center-renovation.vue?vue&type=template&id=38acb59d&"
import script from "./data-center-renovation.vue?vue&type=script&lang=js&"
export * from "./data-center-renovation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports